export default __webpack_public_path__ + "static/media/battery-wire.332bd835.png";